import { Component, input } from '@angular/core';

/**
 * Native-Angular port of the AngularJS `ftInitializedContent` directive
 * (account-v2/.../directives/initialized-content/initializedContent.directive.ts).
 * Wraps content and shows a loading-animation hook until `isInitialized`
 * goes true.
 *
 * The v1 directive wired `ft-loading-animation` for the spinner; native
 * Angular leaves can either gate their own loading UI with `*ngIf` directly
 * OR use this wrapper. The transcluded content is shown via Angular content
 * projection — `[hidden]` instead of v1's `ng-show` to keep DOM stable
 * (matches v1's display:none semantics for parity).
 */
@Component({
    selector: 'ft-initialized-content',
    templateUrl: './initialized-content.component.html',
    standalone: false
})
export class FtInitializedContentComponent {
    readonly isInitialized = input(false);
    /**
     * v1 supported `hide-loading="true"` to skip the spinner. Native leaves
     * typically render their own gate so this is a no-op; kept for binding
     * parity with the original template attribute.
     */
    readonly hideLoading = input(false);
}
